module.exports = __webpack_public_path__ + "img/consulta_procesos.18d0354d.png";